import React from 'react'
import { interpolate } from '../utils/proposalVariables'

const TermsConditions = ({ data, variables }) => {
  const allSections = data?.sections || []
  const visibleSections = allSections.filter(s => !s.hidden)

  return (
    <div className="proposal-section">
      <div className="proposal-section__headline">{data?.headline || 'Terms & Conditions'}</div>
      <div className="proposal-section__accent-line" />
      {visibleSections.map((section, idx) => (
        <div className="proposal-terms__section" key={idx}>
          {section.title && (
            <div className="proposal-terms__section-title">{section.title}</div>
          )}
          {section.content && (
            <div className="proposal-terms__section-content">{interpolate(section.content, variables)}</div>
          )}
        </div>
      ))}
    </div>
  )
}

export default TermsConditions
